import { render } from "./PowerBy.vue?vue&type=template&id=05fc4e0e"
import script from "./PowerBy.vue?vue&type=script&lang=js"
export * from "./PowerBy.vue?vue&type=script&lang=js"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__